exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".category-image {\n  background: url(\"/assets/img/upload.png\") no-repeat center;\n  background-size: 80%;\n  width: 70px;\n  height: 70px;\n  border-radius: 35px;\n  border: solid 1px #c6c6c6;\n  background-color: lightgray;\n  vertical-align: middle; }\n\n.subcategory-image {\n  background: url(\"/assets/img/subcategory.png\") no-repeat center;\n  background-size: 100%;\n  width: 70px;\n  height: 70px;\n  vertical-align: middle; }\n\n.tag-success {\n  background-color: #4dbd74; }\n\n.tag {\n  display: inline-block;\n  padding: 0.25em 0.4em;\n  font-size: 75%;\n  font-weight: bold;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/app/+admin/modules/+category/category-list/category-list.component.scss
// module id = 1071
// module chunks = 12